module.exports = __webpack_public_path__ + "img/event_award.e1c05964.png";